import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h2", null, "tech stack", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_11 = { class: "badge bg-secondary" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("h2", { class: "d-sm-block d-md-none" }, "preview", -1)
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "col mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_viewer = _resolveComponent("image-viewer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h1", _hoisted_5, _toDisplayString(_ctx.$store.state.singlePortfolioItem?.name), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", {
            class: "col-md-12 mt-5",
            innerHTML: _ctx.content
          }, null, 8, ["innerHTML"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("p", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.singlePortfolioItem
                  ?.badges, (badges, side) => {
                return (_openBlock(), _createBlock(_Fragment, { key: side }, [
                  _createVNode("strong", null, _toDisplayString(side) + ":", 1),
                  _hoisted_10,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(badges, (b) => {
                    return (_openBlock(), _createBlock(_Fragment, { key: b }, [
                      _createVNode("span", _hoisted_11, _toDisplayString(b), 1),
                      _hoisted_12
                    ], 64))
                  }), 128)),
                  _hoisted_13
                ], 64))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode("div", _hoisted_18, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.$store.state.singlePortfolioItem?.images, (img) => {
              return (_openBlock(), _createBlock("div", {
                key: img,
                class: "row"
              }, [
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_image_viewer, { src: img }, null, 8, ["src"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}